export default __webpack_public_path__ + "img/b8abdc4eef00d77892916131bcc38d0c.svg";